
import { Vue, Options, prop } from "vue-class-component";
import Title from "@/app/ui/components/data-wrapper/title.vue";
import { DeviceAuth } from '../../../../domain/entities/Account';
import formatDate from '../../../infrastructures/misc/common-library/FormatDate';

class Props {
  modelValue = prop<DeviceAuth[]>({
    type: Array,
    default: []
  });
}

@Options({
  emits: [],
  components: { Title }
})
export default class DeviceAuthSection extends Vue.with(Props) {

  mapDeviceName(device: DeviceAuth): string {
    return `${device.deviceName} (${device.deviceOs})`
  }

  // Format Date
  formatDateToString(date: string) {
    return formatDate(date);
  }
}
